import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BillingStatus } from '../interfaces/billingstatus';
import { AuthService } from '../core/services/auth.service';
import { LayoutService } from "./service/app.layout.service";
import { AppConsts } from 'src/app/core/constraints/appConsts';
import { environment } from 'src/environments/environment';
import { MenuItem } from 'primeng/api';
import { DocumentAIService } from '../shared/services/documentAI.service';
import { event } from 'jquery';
// import { DocumentsComponent } from '../document/components/documents/documents.component';
@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    
})
export class AppTopBarComponent implements OnInit{
    logoClass: string = '';
    logoClass1 : string = '';
    logoPath: string = '../../assets/layout/images/document_with_GPT.svg';
    agentDescription: string = '';
    showRightPanel:boolean=false;
    bill?:BillingStatus;
    selectedOrganization: any;
    displayTaskName :string | undefined
    items: MenuItem[] | undefined;
    tabDisplayClass : boolean = false;
    uniqueOrganizations: any[] = [];
    @ViewChild('menubutton') menuButton!: ElementRef;
    @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;
    @ViewChild('topbarmenu') menu!: ElementRef;
    contactUsUrl = AppConsts.contactUsLink;
    constructor(public layoutService: LayoutService,public authService:AuthService,public router:Router ,public service : DocumentAIService , private renderer: Renderer2) {
       
    }
    ngOnInit(): void {
       this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
            this.setLogoBasedOnUrl();
            }
        });

        //  this.service.filterDocumentName.subscribe((taskName)=>{
        //     this.displayTaskName = taskName
        // });
        
        this.getSelectedOrgName();
        this.items = [
            // {
            //     label: 'Admin',
            //     icon: '../../assets/layout/images/admin.jpg',
            //     visible: this.authService.hasPermission('Pages'),
            //     command:(event)=>{

            //     }
            //     // visible: truew
            // },
            // {
            //     label: 'Contributor',
            //     icon: '../../assets/layout/images/collaborator.jpg',
            //     visible: true

            // },
            // {
            //     label: 'Developer',
            //     icon: '../../assets/layout/images/developer.jpg',
            //     visible: true
            // },
        ];
        this.service.filterDocumentName.subscribe((data) => {
            this.displayTaskName = data
          })  

          this.uniqueOrganizations = this.getUniqueOrganizations(this.authService.loggedInUser.myOrganizations);
    }

setLogoBasedOnUrl() {
    const currentUrl = this.router.url.toLowerCase();
    const logoMap: { [key: string]: { path: string, class: string } } = {
        'accordia': { path: '../../assets/layout/images/accordiaLogo.svg', class: 'custom-logo accordia-color' },
        'alera': { path: '../../assets/layout/images/aleeraLogo.svg', class: 'custom-logo alera-color' },
        'clario': { path: '../../assets/layout/images/clarioLogo.svg', class: 'custom-logo clario-color' },
        'revio': { path: '../../assets/layout/images/revioLogo.svg', class: 'custom-logo revio-color' },
        'solis': { path: '../../assets/layout/images/solisLogo.svg', class: 'custom-logo solis-color' },
        'veris': { path: '../../assets/layout/images/verisLogo.svg', class: 'custom-logo veris-color' }
    };

    let found = false;
    for (const key in logoMap) {
        if (currentUrl.includes(key)) {
            this.logoPath = logoMap[key].path;
            this.logoClass = logoMap[key].class;
            this.logoClass1 = 'custom-logo-Alera';
            this.agentDescription = 'Ai Agent for Patient intake & Referrals';
            const tabPanels = document.querySelector('.layout-sidebar');
            this.renderer.addClass(tabPanels, 'layoutSidebarAccordia');
            found = true;
            break;
        }
    }

    if (!found) {
        this.logoPath = '../../assets/layout/images/document_with_GPT.svg';
        this.logoClass = '';
        this.logoClass1 = '';
        this.agentDescription = '';
    }
}

    getSelectedOrgName() {
        this.selectedOrganization = this.authService.loggedInUser.myOrganizations.find(org => org.tenantKey === this.authService.loggedInUser.activeTenantKey);
        localStorage.setItem("organizationId", this.selectedOrganization.id );        
    }

    OnChangeOrganization($event:any)
    {

        localStorage.setItem("organization_tenant_key", this.authService.loggedInUser.activeTenantKey );
        this.getSelectedOrgName();
        this.authService.loggedInUser.userPermissions=[];
        this.authService.set_UserPermissions_And_BillingStatus(true);
    }
    logout(){
        this.authService.logout();
    }
    manegeSubscriptions(){
        let cloud_dashboard_url=environment.cloud_dashbord_link;
        window.open(cloud_dashboard_url, "_blank");
    }
    gotoSupport() {
        let contactUs = environment.supportlink
        window.open(contactUs, '_blank');
      }
      gotoHome() {
        if(this.authService.loggedInUser.bill?.status == 'Blocked') {
            return;
        }
        this.router.navigate(['document/sortis'])
      }
      AddClass(){
        this.tabDisplayClass = !this.tabDisplayClass
        if(this.tabDisplayClass === true){
            const tabPanels = document.querySelector('.p-tabview-panels');
            this.renderer.addClass(tabPanels, 'tabDisplayBlockMenu');

            const openmenu = document.querySelector('.imageUploadDoc');
            this.renderer.addClass(openmenu, 'menu-open-image');
            const layoutWrapperElement = document.querySelector('.layout-wrapper');
            this.renderer.addClass(layoutWrapperElement, 'layout-static-inactive');
            
        }else{
            const tabPanels = document.querySelector('.p-tabview-panels');
            this.renderer.removeClass(tabPanels, 'tabDisplayBlockMenu');

            const openmenu = document.querySelector('.imageUploadDoc');
            
            this.renderer.removeClass(openmenu, 'menu-open-image');

            const layoutWrapperElement = document.querySelector('.layout-wrapper');
            this.renderer.removeClass(layoutWrapperElement, 'layout-static-inactive');
           

        }
      }

      getUniqueOrganizations(organizations: any[]): any[] {
        return organizations.filter((org, index, self) =>
            index === self.findIndex((o) => o.tenantKey === org.tenantKey)
        );
    }
      
}
